import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import NewQueryTool from '@containers/DigitalAnalyst/NewQueryTool';
import { AI_TOOLS, DOC_SELECT_MODES } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function WebDigitalAnalyst() {
  const navigate = useNavigate();
  const [docModes] = React.useState([DOC_SELECT_MODES.website, DOC_SELECT_MODES.myDocs, DOC_SELECT_MODES.allCompany]);

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <NewQueryTool
          onGoBack={onGoBack}
          isWebMode
          tool={AI_TOOLS.WEBSITE_DOCS}
          docModes={docModes}
          defaultActiveDocSelectMode={DOC_SELECT_MODES.website}
        />
      </Body>
    </PageWrapper>
  );
}

export default WebDigitalAnalyst;
